
import { defineComponent } from 'vue'
import { HoundModel } from '../../../../common'
import breakpoints from '../../utils/breakpoints';

export default defineComponent({
  name: 'HoundSelectOption',
  props: {
    hound: {
      type: HoundModel,
      required: true
    },
    infoMarginLeft: {
      type: String,
      default: '10rem'
    },
    ellipsisSmMax: {
      type: String,
      default: '10rem'
    },
    showSex: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      hound: props.hound,
      infoMarginLeft: props.infoMarginLeft,
      showSex: props.showSex,
      breakpoints,
      ellipsisSmMax: props.ellipsisSmMax,
      disabled: props.disabled
    }
  },
})
